import { Box, useBreakpoints } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { Outlet, useParams } from "react-router"
import {
	useUnreadTitleFlash,
	WhatsAppInboxThreadsList,
} from "../../../../WhatsAppMessages"

const BASE_TITLE = "WhatsApp Inbox"

export default function WhatsAppInboxLayoutPage() {
	// The child `[threadId]` route contributes the selected id; the list highlights it.
	const params = useParams()
	const activeThreadId = params.threadId ? Number(params.threadId) : undefined

	// While the tab is backgrounded with unread messages, blink the count into the
	// tab title — the universal fallback for when the sound is muted or blocked
	// (iOS). Helmet keeps the steady title; the blink writes document.title direct.
	useUnreadTitleFlash()

	// Three panes only fit on wide screens; below that we show one pane at a
	// time (list, then the conversation).
	const { lg, xl } = useBreakpoints()
	const isDesktop = lg || xl

	const shellStyle = {
		height: "calc(100vh - 57px)",
		minHeight: 0,
	} as const

	if (!isDesktop) {
		return (
			<>
				<Helmet>
					<title>{BASE_TITLE}</title>
				</Helmet>
				<Box borderTopWidth="1" style={{ ...shellStyle, overflow: "hidden" }}>
					{activeThreadId ? (
						<Outlet />
					) : (
						<WhatsAppInboxThreadsList activeThreadId={activeThreadId} />
					)}
				</Box>
			</>
		)
	}

	return (
		<>
			<Helmet>
				<title>{BASE_TITLE}</title>
			</Helmet>
			<Box
				display="grid"
				borderTopWidth="1"
				style={{
					...shellStyle,
					gridTemplateColumns: "340px minmax(0, 1fr)",
				}}
			>
				<Box
					borderRightWidth="1"
					bgColor="default"
					style={{ minHeight: 0, overflow: "hidden" }}
				>
					<WhatsAppInboxThreadsList activeThreadId={activeThreadId} />
				</Box>
				<Box style={{ minHeight: 0, overflow: "hidden" }}>
					<Outlet />
				</Box>
			</Box>
		</>
	)
}
